// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"social-proof_wrapper__NSI8P","illustration":"social-proof_illustration__WELSL","content":"social-proof_content__XOV47","note":"social-proof_note__De0YA"};